"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Error;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Error(_ref) {
  var error = _ref.error;
  console.log("Chyba při zpracování: ", error);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gov-alert gov-alert--error"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gov-alert__content"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Chyba p\u0159i zpracov\xE1n\xED. Opakujte pros\xEDm pozd\u011Bji.")), /*#__PURE__*/_react["default"].createElement("button", {
    className: "gov-button--icon-only gov-alert__close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gov-icon gov-icon--cross"
  })));
}
//# sourceMappingURL=Error.js.map